/******************************/
/*   */
/*   */
/******************************/

function ruecken_staerke() {
	var grammatur_inhalt = document.form_ruecken.grammatur_inhalt.value;
	var seiten_inhalt = document.form_ruecken.seiten_inhalt.value;
	var volumen_inhalt =  1; //document.form_ruecken.volumen_inhalt.value;

	// Berechnung
	var erg_umschlag = 0.3;
	var erg_gesamt = eval(seiten_inhalt/2 * grammatur_inhalt/80 * 0.1 * volumen_inhalt)+erg_umschlag; // Staerke Inhalt
	// Ausgabe
	//alert("U:"+erg_umschlag+"| C:"+erg_cover.toFixed(2)+"| V:"+erg_vorsatz.toFixed(2)+"| I:"+erg_inhalt.toFixed(2)+"| G:"+erg_gesamt.toFixed(2));
	var textnode = document.createElement('span');
	textnode.className="success";
	textnode.appendChild(document.createTextNode(erg_gesamt.toFixed(1)+" mm"));

	var ausgabefeld = document.getElementById("output");
	while(ausgabefeld.hasChildNodes())
		ausgabefeld.removeChild(ausgabefeld.lastChild);
    ausgabefeld.appendChild(textnode);
}
  
function printErr(x) // Ausgabe Fehlermeldung
{
    var ausgabefeld = document.getElementById("ausgabe_fehler");
    ausgabefeld.removeChild(ausgabefeld.lastChild);
    ausgabefeld.appendChild(document.createTextNode(x));
}